module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_activities03-2a9a3909d6137cdb1458279e139e55a8.jpg";